module.exports = __webpack_public_path__ + "static/media/provi-small.69fcc2c2.svg";